import * as React from 'react';

import { Helmet } from 'react-helmet-async';

import { PrimitiveResult } from 'components';

export default function Home() {
  return (
    <React.Fragment>
      <Helmet>
        <title>داشبورد | کاشی لند</title>
      </Helmet>
      <PrimitiveResult
        status='info'
        title='در حال بررسی'
        subTitle='صفحه اصلی در حال بررسی و اجرا می‌باشد.'
      />
    </React.Fragment>
  );
}
